const home = resolve => require(['@/components/workbench/workbench/index.vue'], resolve);
// import home from '/components/workbench/workbench.vue'
export default [{
    path: '/homeMain/workbench/workbench',
    component: home,
}]


// WEBPACK FOOTER //
// ./src/router/workbench.js